import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.7813 8.00047L5.48145 4.70062L6.42426 3.75781L10.6669 8.00047L6.42426 12.2431L5.48145 11.3003L8.7813 8.00047Z", fill: "#CCCCCC" }));
const ForwardRef = forwardRef(SvgArrowRight);
const Memo = memo(ForwardRef);
export default Memo;
